import { OptionsClass } from "@/domain/entities/MainApp";

export const INTEGRATION_PLATFORMS: OptionsClass[] = [
  {
    name: "Shopify",
    value: "shopify",
    label: "Shopify",
    key: "Connect Lion Parcel with Shopify to manage your orders more easily.",
    meta: { icon: "shopify", totalConnected: 0 },
    disabled: false
  },
  {
    name: "API Lion Parcel",
    value: "API Lion Parcel",
    label: "Your Store Domain",
    key: "Connect Lion Parcel with your store domain to manage your shipments.",
    meta: { icon: "custom", totalConnected: 0 },
    disabled: false
  },
  {
    name: "Woocommerce",
    value: "woocommerce",
    label: "Woocommerce",
    key:
      "Connect WooCommerce and transform the way you manage your orders and shipments.",
    meta: { icon: "woo", totalConnected: 0 },
    disabled: false
  },
  {
    name: "Opencart",
    value: "opencart",
    label: "Opencart",
    key: "Connect Opencart to manage your orders & shipments in one dashboard.",
    chipLabel: "Coming Soon",
    meta: { icon: "opencart", totalConnected: 0 },
    disabled: true
  },
  {
    name: "Magento (Adobe Commerce)",
    value: "magento",
    label: "Magento",
    key:
      "Connect Magento & enjoy features to manage your orders & shipments more efficiently.",
    chipLabel: "Coming Soon",
    meta: { icon: "magento", totalConnected: 0 },
    disabled: true
  },
  {
    name: "PrestaShop",
    value: "prestashop",
    label: "PrestaShop",
    key: "Connect PrestaShop to easily manage your shipments.",
    chipLabel: "Coming Soon",
    meta: { icon: "presta-shop", totalConnected: 0 },
    disabled: true
  }
];

export const INTEGRATION_PLATFORM_ENGLISH_COPY: Record<
  string,
  { label: string; key: string; chipLabel?: string }
> = {
  shopify: {
    label: "Shopify",
    key: "Connect Lion Parcel with Shopify to manage your orders more easily."
  },
  "API Lion Parcel": {
    label: "Your Store Domain",
    key: "Connect Lion Parcel with your store domain to manage your shipments."
  },
  woocommerce: {
    label: "Woocommerce",
    key:
      "Connect WooCommerce and transform the way you manage your orders and shipments."
  },
  opencart: {
    label: "Opencart",
    key: "Connect Opencart to manage your orders & shipments in one dashboard.",
    chipLabel: "Coming Soon"
  },
  magento: {
    label: "Magento",
    key:
      "Connect Magento & enjoy features to manage your orders & shipments more efficiently.",
    chipLabel: "Coming Soon"
  },
  prestashop: {
    label: "PrestaShop",
    key: "Connect PrestaShop to easily manage your shipments.",
    chipLabel: "Coming Soon"
  }
};

export const ERROR_GENERATE_TYPE = {
  "Nama toko sudah digunakan. Coba lainnya": "appName",
  "Domain sudah digunakan. Coba lainnya": "domain"
} as const;
